import { cn } from '@core/utils/cn';

export type ButtonVariant =
  | 'primary'
  | 'ghost'
  | 'outline'
  | 'admin'
  | 'danger'
  | 'dangerGhost'
  | 'subtle';
export type ButtonSize = 'sm' | 'md' | 'lg';

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap ' +
  'transition-[transform,background-color,box-shadow,border-color] duration-200 ' +
  'border border-transparent cursor-pointer select-none active:scale-[0.98] ' +
  'disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none ' +
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent';

const VARIANTS: Record<ButtonVariant, string> = {
  primary:
    'bg-accent text-accent-ink shadow-[0_8px_26px_-8px_rgba(62,166,255,0.6)] ' +
    'hover:-translate-y-0.5 hover:shadow-[0_14px_34px_-8px_rgba(62,166,255,0.75)] active:translate-y-0',
  ghost: 'bg-transparent text-text border-[var(--btn-ghost-bd)] hover:bg-[var(--btn-ghost-hover)]',
  outline: 'bg-transparent text-accent border-accent hover:bg-accent/10',
  admin:
    'bg-accent text-accent-ink shadow-[0_8px_26px_-8px_rgba(62,166,255,0.6)] ' +
    'hover:-translate-y-0.5 hover:shadow-[0_14px_34px_-8px_rgba(62,166,255,0.75)] active:translate-y-0',
  danger: 'bg-danger text-danger-ink hover:-translate-y-0.5 active:translate-y-0',
  dangerGhost: 'bg-transparent text-danger border-transparent hover:border-danger/40 hover:bg-danger/10',
  subtle: 'bg-card text-text border-line hover:border-muted',
};

const SIZES: Record<ButtonSize, string> = {
  sm: 'text-xs px-3.5 py-2 min-h-9',
  md: 'text-sm px-5 py-2.5 min-h-11',
  lg: 'text-base px-7 py-3.5 min-h-12',
};

export function buttonVariants(variant: ButtonVariant = 'primary', size: ButtonSize = 'md'): string {
  return cn(BASE, VARIANTS[variant], SIZES[size]);
}
